export default {
  //General phrases
  tollWord: "Taksa ćuprije fetesti | taksa ćuprije fetesti | Peaje",
  vignetteWord: "Rovinieta | Roviniete",

  site_tpf: "taksa-ćuprije-fetesti.ro",
  site_erv: "e-rovinieta.ro",

  currency: "lei",
  category: "kategorija",
  select_type_of_vehicle: "izaberi vrstu vozila",
  select_the_period: "Select the period",
  or_pay_for: "ili plati za",
  your_vehicles_link: "tvoja vozila",
  or_go_to_your_account_and_buy:
    "Ili uđi u tvom nalogu i direktno kupi za tvoja vozila",
  see_cart: "potrošačka korpa",
  or: "ili",
  and: "i",
  back: "nazad",
  total: "Totalno",
  pf: "Fizičko lice",
  pj: "Pravno lice",
  yes: "Da",
  no: "Ne",
  about: "O",
  us: "Mi",

  vignette: "rovinieta | roviniete",
  passing: "Prelaz | prelazi",

  toll_buy: "Plati taksu za ćupriju",
  vignette_buy: "Plati rovinieta",

  //Order
  billing_add_new_profile: "Dodaj novi profil za izdavanje računa",

  cart_empty: "Korpa je prazna",
  cart_available_from: "važeće od",
  cart_add_more: "Nastavi da dodaješ u korpi ostale",
  cart_continue_with_buying: "Kupuj još",
  cart_validation_errors:
    "Proizvodi izvađeni iz naloga zbog greška u validiranju",

  order_container_place_order_title: "Postavi nalog",
  order_container_my_cart: "Moja korpa",
  order_container_billing_info: "Podaci o računu",
  order_container_payment: "Plaćanje",

  payment_method_insuficient_credit: "Nedovoljan kredit",
  payment_method_instant_credit: "Instant kredit",
  payment_method_instant_credit_description: "Instant kredit",
  payment_method_credit_card: "Online sa bankovnom karticom",
  payment_method_credit_card_description:
    "Plaćanje biće procesirano kroz PayU.ro",
  payment_method_iTransfer_description: "Nalog za plaćanje sa brzom potvrdom",
  payment_method_payment_order: "Nalog za plaćanje",
  payment_method_payment_order_description:
    "E-poštom ćete dobiti predračun koji se odnosi na kupovinu i sadrži uputstva za plaćanje. Nalog će biti izdat po prijemu uplate",
  payment_method_credit_erv: "Kredit e-rovinieta",
  payment_method_credit_tpf: "Kredit takaa ćuprije fetesti",
  payment_method_terms:
    "Potvrđujem da su gornji podaci i da sam pročitao i slažem se sa uslovima i odredbama",

  thank_you_placed_order_title: "Postavljena narudžbina",
  thank_you_successful_order: "Narudžbina je uspešno postavljena!",
  thank_you_see_info_order: "Pogledaj status u mojim narudžbinama",
  thank_you_my_orders: "Moje narudžbine",

  //Account
  continue_with: "Continue with",
  account_activate_header: "Aktiviraj račun",
  account_activate_message: "",

  account_container_my_account: "Moj nalog",
  account_container_vehicles: "Vozila",
  account_container_orders: "Narudžbine",
  account_container_profiles: "Profili za izdavanje računa",
  account_container_info: "Podaci naloga",

  account_data_title: "Detalji naloga",

  add_car_title: "Dodavanje vozila",

  add_profile_title: "Dodavanje profila",
  add_profile_pj_extracted: "Podaci pravnog lica automatski izvađeni",

  edit_car_no_vehicles: "Nije pronađeno nijedno vozilo!",
  edit_car_delete_vehicle_title: "Ubriši vozilo",
  edit_car_delete_vehicle: "Siguran si da želiš da ubrišeš ovo vozilo?",

  my_orders_passings: "jedan prelaz | {count} prelazi",

  profiles_main: "Glavni",
  profiles_secondary: "Sekundardni",
  profiles_unverified_data: "Ne provereni podaci",
  profiles_no_profile: "Ne postoji nijedan profil",
  profiles_delete_profile: "Ubriši profil",
  profiles_are_you_sure: "Siguran si da želiš da ubrišeš profil?",

  //Authentication
  login_auth: "Prijavljivanje",
  login_login_into_your_account: "Uđi u tvom nalogu",

  login_component_login_by: "Login sa",
  login_component_no_account: "Nemaš nalog?",
  login_component_forgot_password: "Заборавили сте лозинку?",

  new_account_title: "Novi nalog",
  new_account_details: "Detalji naloga",
  new_account_ive_read: "Čitao sam i prihvatam",
  new_account_tc: "Termini i uslovi",
  new_account_site: "internet stranice",
  new_account_pc: "Politika o poverljivosti",
  mandatory: "Obavezno",
  new_account_must_accept_tc: "Moraš prihvatiti termine i uslove",
  new_account_must_accept_pc: "Moraš prihvatiti politiku o poverljivosti",

  contact_title: "Kontakt",

  header_how_does_it_work: "Kako funkcionipše?",

  how_it_works_p1: "Krećeš na put u tri minuta!",
  how_it_works_p2: "Ovlašćeni dobavljač CNAIR",
  how_it_works_p3: "naruči online sa taksa-ćuprije-fetesti.ro",

  toll_category_error_loading_car: "Problem kod učitavanje vozila",
  toll_category_error_loading_country: "problem kod učitavanje zemlje",

  vignette_category_error_fromdate:
    "Izaberite datum kada će rovinieta stupiti na snagu",

  //Buttons
  btn_save: "Spasi",
  btn_save_changes: "Spasi promene",
  btn_add_car: "Dodaj vozilo",
  btn_delete_car: "Ubriši vozilo",
  btn_next_step: "Sledći korak",
  btn_finish: "Dovrši",
  btn_grab_data_company: "Preuzmi podatke<br/> Privredni registar",
  btn_add_profile: "Dodaj novi profil",
  btn_i_understand: "Razumeo sam",
  btn_login: "Login",
  btn_register: "registruj se",
  btn_create_account: "Stvori nalog",
  btn_add_to_cart: "Dodaj u korpi",
  btn_edit_to_cart: "Измените производ",
  btn_reset_password: "Ресетуј шифру",
  btn_bill: "Factureaza",
  btn_choose_payment_method: "Choose payment method",

  //Labels
  label_email: "Email",
  label_password: "Lozinka",
  label_confirm_password: "Potvrdi lozinku",
  label_license_plate: "Br. registracije",
  label_chasis_number: "Serija šasije",
  label_registration_country: "Zemlja registracije",
  label_motif: "Razlog niže kategorije",
  label_choose_category: "Izaberi kategoriju za",
  label_billing_type: "Izdavanje računa na",
  label_last_name: "Ime",
  label_first_name: "Prezime",
  label_country: "Zemlja",
  label_county: "Okrug",
  label_city: "Grad",
  label_address: "Adresa",
  label_cui: "PIB",
  label_reg_com: "Privredni registar",
  label_locality: "Mesto",
  label_company_name: "Naziv kompanije",
  label_for_car: "Za vozilo",
  label_available_from: "Valjanost od",

  //terms
  terms: "Услови",
  partners: "партнер",

  delete_product_title: "Delete product",
  delete_product: "Are you sure you want to delete this product?",

  //New terms
  btn_edit: "Promeni",
  btn_edit_password: "Promeni lozinku",
  btn_edit_phone: "Promeni telefon",
  btn_delete_account: "Briši račun",
  btn_import_csv: "Uvoz csv",
  btn_export_csv: "Izvoz csv",

  //account
  data_saved_succesfully: "Uspešno spašeni podaci",
  invalid_plate_number_message: "broj nema tačan format",
  invalid: "Nevažeći",
  countries_loading: "Problem kod učitavanja država",
  tpf_categories_loading:
    "Problem kod učitavanja kategorije      taksa za čupriju Fetesti",
  erv_categories_loading: "Problem kod učitavanja kategorija vinjete",
  csv_header:
    "Broj, šasija, kategorija vinjete, kategorija taksa pod fetesti, Država",
  order_header_name: "Ime",
  date: "Datum",
  order_header_payment_type: "Vrsta plaćanja",
  order_header_status: "Status",
  no_placed_order: "Ne postoji nijedna upisana narudžbina",
  i_want: "hoću",
  no_order: "Narudžbina nije pronađena",

  product_status: "Status",
  product_payment_method: "metoda plaćanja",
  product_bill_data: "Podaci izdavanja računa",
  product_valability: "Valjanost",

  download_bill: "Preuzmi račun",
  vignette_series: "Serija vinjete",
  toll_series: "Serija cestarine",

  //authentication
  login_account: "Ulazak u nalog",
  password: "Lozinka",
  password_confirm: "Ponovi lozinku",
  return_to_login_1: "Vrati se na stranicu",
  return_to_login_2: "Priključi se",

  // order
  choose_profile: "Izaberi jedan profil",
  order_step4: "Pasul 4: Izdavanje računa",
  login_to_your_account: "Uđi u svom nalogu",
  login_to_your_account_2: "I izaberi već spašene podatke o izdavanju računa",
  order_without_account:
    "Možete upisati narudžbinu bez naloga kroz popunjavanje podataka",
  fill_all_fields: "Popuni sva obavezna polja",
  order_address_info: "Na ovoj adresi ćeš primiti račun u vinjetu",
  invalid_profile_msg: "Ovaj profil nije validan",
  delete_profile_msg: "Briši profil",
  delete_profile_confirm: "Siguran si da želiš da brišeš profil",
  invalid_email: "Email nije važeći",
  invalid_tel: "Telefon nije važeći",
  mandatory_city: "Grad je obavezan",
  mandatory_first_name: "Ime je obavezno",
  mandatory_last_name: "Prezime je obavezno",
  mandatory_country: "Okrug je obavezan",
  mandatory_fiscal_code: "OIB je obavezan",
  mandatory_j_code: "Privredni registar je obavezan",
  mandatory_company: "Kompanija je obavezna",
  mandatory_address: "Adresa je obavezna",
  my_shopping_cart: "Moja kolica",
  order_step3: "Pasul 3: Sažetak",
  buy_vignette_or_bridge_fee: "Kupi vinjetu ili plati taksu za pod Fetesti",
  order_step5: "Peti korak: Plaćanje",
  warning: "PAŽNJA!",
  warning_txt_1:
    "Za plaćanje vinjeta iz naloga za plaćanje narudžbina će biti odobrena nakon ulaska novca u bankovnom računu UNTRR",
  warning_txt_2:
    "Plaćene vinjete sa nalogom za plaćanje izdaju se od ponedelljka do petka od 08:00 do 16:30 časova",
  warning_txt_3:
    " Ne polazite na put dok ne primite potvrdu za izdavanje vinjete",
  warning_txt_4: "UNTRR nije odgovoran za nepoštovanje gore upisanih uslova!",
  choose_card: "Izaberi jednu od spašenih kartica",
  new_card: "Nova kartica",
  add_card_for_next_transactions: "Dodaj karticu u nalogu za buduće kupovine",

  free: "Besplatno",
  btn_logout: "Isključenje",
  info: "Info",

  frequent_questions_heading: "Česta pitanja i odgovori",
  see_all_frequent_questions: "Pogledaj sva pitanja i odgovore",

  step: "Step {n}",
  choose_passings_number: "Izaberi broj prelaza",
  vehicles: "Vozila",

  juridical_person: "Pravno lice",
  individual_person: "Fizičko lice",
  auto_query_company_data: "Preuzmite automatski podatke firme",
  verified_company_data: "Provereni podaci kompanije",
  unverified_company_data: "Ne provereni podaci kompanije",
  check_vignette_valability: "Proveri valjanost vinjete",
  resources: "Resursi",
  i_want_vignette: "Hoću vinjetu",
  i_want_toll: "Hoću taksu pod Fetesti",
  vehicle_type: "Tip vozila ",
  period: "Period",
  summary: "Sažetak",
  billing: "Izdavanje računa",
  payment: "Plaćanje",
  you_have_multiple_usernames:
    "Imate <b>{ račun}</b> nalozi koji se odnose na ovaj e-mail",
  choose_login_account: "Izaberite nalog sa kojim želite da se autentificirate",

  //benefits page
  bp_company_advantages: "Prednosti za kompanije",
  bp_one_account_multiple_advantages: "Jedan nalog, više prednosti",
  bp_contact_us_for_personalized_solution:
    "Kontaktirajte nas za personalizirano rešenje",
  bp_online_emission: "Izdavanje online 24/7",
  bp_online_assistance:
    "Imate on line pomoć i možete kupiti vinjetu ili taksu za čupriju pod Fetesti 24/7",
  bp_import_your_cars: "uvodite celi auto park",
  bp_import_you_cars_through_excel:
    "Unosite kod nas celi auto park firme, na osnovu jednog excel dokumenta",
  bp_multiple_profiles: "Više profila",
  bp_multiple_profiles_for_same_email:
    "Imate mogućnost da stvorite više profila za sve korisnike firme sa istom e-mail adresom",
  bp_vignettes_status: "Status vinjete",
  bp_verify_vignette_status:
    "Na internet stranici možete bilo kad proveriti status izdatih vinjeta",
  bp_orders_history: "Istorija narudžbina",
  bp_orders_history_description:
    "U okviru naloga možete naći sve naloge upisane u računima",
  bp_multiple_orders: "Višestruke narudžbine",
  bp_multiple_orders_description:
    "Možete dodati više vinjeta u nalogu za plasiranje više naloga",
  bp_email_sms_confirmation: "Potvrda kroz e-mail i SMS",
  bp_email_sms_confirmation_description:
    "Primite potvrdu izdavanja vinjete kroz e-mail i SMS",
  bp_expiry_alerts: "Upozorenje o isteku",
  bp_expiry_alerts_description:
    "Za vinjete od više od 30 dana primate upozotenje preko e-mail pre isteka",
  bp_need_help: "Imate nevolju za pomoć",
  bp_call_operators:
    "Nazovite jednog od naših operatera za pomoć u izdavanje vinjeta. Naša služba je dostupna od ponedeljka do petka (osim legalnih praznika) između 8 i 17 časova",
  bp_offices: "Spisak zastupništva",
  bp_have_cars: "Imate jednu flotu vozila?",
  bp_contact_us_for_personalized_solution_for_your_bussiness:
    "Stupite sa nama u kontaktu radi primanja jednog personaliziranog rešenja za vaše poslovanje",
  bp_contact_us_now: "Kontaktirajte nas sada",

  //contact
  contact_viggnete_emission: "Izdavanje vinjeta",
  contact_agencies: "Agencije",
  contact_see_all_agencies: "Vidi sve regionalne agencije",
  contact_see_all_agencies_continuation: "Odakle možete uzeti vinjete",

  //distribution
  distribution_header:
    "SPISAK RADNIH JEDINICA POSLAN UNTRR ZA NAPLAĆIVANJE TARIFE ZA KORIŠTENJE MREŽE NACIONALNIIH PUTEVA RUMUNIJE (VINJETA) ",
  distribution_nr_crt: "Broj kriterija",
  distribution_work_point: "Radna jedinica",
  distribution_terminals_and_portals: "WEB TERMINALI I PORTALI",
  distribution_name: "Naziv",
  distribution_terminals: "Terminali ZEBRAPAY",
  distribution_location_terminal_details: "Detalji lokacija terminala ZEBRAPAY",
  distribution_untrr_portal: "PORTAL UNTRR",

  //footer
  footer_copyright:
    "Sva prava su rezervirana 2010-2020 @ Nacionalni savez putnih transportera Rumunije.",

  //homepage
  homepage_authorized_distributor: "Ovlašćen distributer   C.N.A.I.R",
  homepage_buy_tpf_erv: "Kupite vinjetu ili taksu pod Fetesti",
  homepage_ready_for_road: "Odmah spreman za put",
  homepage_order: "Narudžbina",
  homepage_payment: "Plati",
  homepage_drive: "Saobraćaj",
  homepage_your_advantages: "Tvoje prednosti",
  homepage_vignette_availability: "Proveri valjanost vinjete",
  homepage_vignette_availability_description_1:
    "Ne znaš dali imaš valjanu vinjetu? Izbegavajte kaznu .",
  homepage_vignette_availability_description_2: "Proveri valjanost ovde",
  homepage_save_data: "Spasi podatke",
  homepage_save_data_description:
    "Napravi nalog, spasi podatke, kupi vinjetu za taksu pod Fetesti sve na istom mestu",
  homepage_sms_email_delivery: "Isporuka kroz mail i SMS",
  homepage_sms_email_delivery_description: "Isporuka kroz e-mail i SMS",
  homepage_card_or_op: "Platite kroz karticu ili OP",
  homepage_card_or_op_description:
    "Brza kupovina i sigurna kroz bankovni račun ili nalog za plaćanje",
  homepage_notify_expiry: "Obaveštenje o isteku",
  homepage_notify_expiry_description:
    "Za vinjete za period veći od 30 dana obaveštavamo vas pre isteka",
  homepage_professional_services: "Stručne usluge",
  homepage_professional_services_description:
    "Od stručnjaka u transportu za sve koristike mreže puteva Rumunije",
  homepage_online_assistance:
    "Dodatno imaš on line pomoć i možeš koristiti jedno personalizirano rešenje za nevolje svoje firme.",
  homepage_discover_all_benefits: "Pronađi sve koristi",
  homepage_distribution_points: "Tačke za distribuciju",
  homepage_authorized_distributor_2:
    "UNTRR je ovlašćeni distributer za CNAIR za izdavanje elektronskih vinjeta sa prisustvom u on line sredini sa teritorijalnim tačkama",
  homepage_distribution_points_description:
    "Pogledaj spisak tačka za distribuciju",
  homepage_frequent_questions: "Česta pitanja i odgovori",
  homepage_frequent_questions_description: "Pogledaj sva pitanja i odgovore",

  //info
  info_download_file: "Preuzmi datoteke",

  //reset
  reset_cart: "Kolica su bila resetirana",

  sms_notice:
    "<strong>Usluga SMS obaveštenja na osnovu plaćanja</strong><br/><br/> Usluga obaveštavanja kratkih poruka (SMS) omogućava obaveštavanje klijenata www.taxa-pod-fetesti.ro radi potvrde o izdavanju путарина за мостове, odnosno obaveštenja klijenata o isteku roka važenja путарина за мостове. Usluga je opciona, po izboru kupca i važi samo za porudžbine koje se plaćaju onlajn preko procesora plaćanja (PaiU).<br/><br/> Ispravnost podataka i informacija u SMS-u o izdavanju i/ili isteku путарина за мостове, registarskog broja, serije šasije i broja mobilnog telefona, unetih na platformi www.taxa-pod-fetesti.ro, striktno su odgovornost korisnika.<br/><br/> SMS obaveštenje se vrši preko NETOPIA Payments.<br/><br/> Sistem SMS obaveštenja šalje obaveštenja korisnicima koji se odluče za ovu uslugu.<br/><br/> Na prijem potvrde / SMS-a isteka može uticati rad i pokrivenost telekomunikacionih mreža, rad uređaja koji se koriste itd.<br/><br/> Za obaveštenja koristite kontakt stranicu internet stranice www.taxa-pod-fetesti.ro.<br/><br/>",
};
